<template>
  <div class="video-player">
    <div class="video-tool-bar">
      <div class="video-close-btn" @click="close">关闭</div>
    </div>
    <video :src="url" controls />
  </div>
</template>

<script>
import VueVideoPlayer from '@videojs-player/vue'
import 'video.js/dist/video-js.css'

export default {
  name: 'VideoPlayer',
  components: {
    VueVideoPlayer
  },
  props: {
  },
  data: {
    url: '',
  },
  mounted() {
    console.log('url', this.url)
  },
  methods: {
    close() {
      console.log(this.$el.remove())
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.video-player {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: #000000db;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .video-tool-bar {
    width: 100%;

    .video-close-btn {
      float: right;
      margin-right: 5%;
      color: white;
    }
  }

  video {
    width: 80%;
  }
}
</style>
